<template>
    <teleport to="#app-sidebar">
        <AppCart v-if="images != ''" />

        <div v-else id="app-cart-empty" class="uk-container uk-flex-auto">
            <div class="uk-margin">
                <h3 class="uk-text-center uk-margin-remove-bottom uk-h2">Basket</h3>
                <p class="uk-text-center">Your Basket is empty</p>
            </div>
        </div>
    </teleport>

    <div v-if="images != ''" class="uk-text-center">
        <h1>{{ eventData.name }}</h1>
        <p class="uk-text-large">View your images in the products tab.</p>
        <div class="uk-margin" uk-grid>
            <div class="uk-width-1-2 uk-text-left" uk-margin>
                <router-link class="uk-margin-right uk-button uk-button-large uk-button-primary uk-rounded" :to="{ name: 'Products' }">Go to Products</router-link>
            </div>
            <div class="uk-width-1-2 uk-text-right">
                <button @click="startAgain()" class="uk-margin-right uk-button uk-button-large uk-button-secondary uk-input-rounded">
                    <span>Start Again</span>
                </button>
            </div>
        </div>
        <div id="help"><BlockHelp /></div>
    </div>

    <div v-else class="">
        <h1>Event Photos</h1>
        <p class="uk-text-large">To get started, enter your details in the form below.</p>

        <div v-if="images == ''" id="app-login" class="uk-flex uk-flex-middle uk-width-1-1 uk-width-medium uk-margin">
            <Form
                @submit="submit()"
                id="payment-form"
                :validation-schema="form_schema.validation"
                v-slot="{ errors }"
                class="uk-width-1-1"
            >
                <div class="uk-child-width-1-1" uk-grid>
                    <div>
                        <div class="uk-card uk-card-primary uk-card-body uk-rounded">
                            <div class="uk-grid-small" uk-grid>
                                <div
                                    v-for="field in form_schema.online_code" :key="field.key"
                                    class="uk-width-1-1" >
                                    <label class="uk-h3" for="form-stacked-text">{{ field.label }}</label>
                                    <div class="uk-text-small">{{ field.help }}</div>
                                    <Field
                                        class="uk-input uk-rounded"
                                        :placeholder="field.label"
                                        :name="field.name"
                                        as="input"
                                        :class="{ 'uk-form-danger': errors.[field.name] }"
                                        :value="customer.[field.name]"
                                        @input="updateCustomer"
                                    />
                                    <div class="invalid-feedback">{{ errors.[field.name] }}</div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div>
                        <button class="uk-button uk-button-large uk-width-1-1 uk-button-primary uk-rounded">
                            <span v-if="loading">
                                Loading Gallery <div uk-spinner></div>
                            </span>
                            <span v-else>Start</span>
                        </button>
                    </div>

                    <div v-if="response.error">
                        <div class="uk-alert-danger" uk-alert>
                            <a class="uk-alert-close" uk-close></a>
                            <p>{{ response.error }}</p>
                        </div>
                    </div>
                </div>
            </Form>
        </div>

        <div id="help"><BlockHelp /></div>
    </div>
</template>

<script>
import AppCart from "@/components/app/Cart"
import BlockHelp from "@/components/blocks/Help"

import { mapState, mapActions, mapGetters } from 'vuex'

import { Form, Field } from 'vee-validate'
import * as Yup from 'yup'

export default {
    components: {
        AppCart,
        BlockHelp,
        Form,
        Field,
    },

    data () {
        return {
            loading: false,
            response: [],
            form_schema: {
                online_code: [
                    { label: 'Email Address', name: 'email',      as: 'input', help: '', },
                    { label: 'Event Code',    name: 'event_code', as: 'input', help: 'Please enter the event code', },
                ],

                validation: Yup.object().shape({
                    email:       Yup.string().email('Email format is invalid').required('Email is required'),
                    event_code:  Yup.string().required('Event code is required'),
                }),
            },
        }
    },

    mounted() {
    },

    computed: {
        ...mapState({
            cartProducts: state => state.cart_products,
            payment: state => state.payment,
        }),
        ...mapGetters({
            customer: 'customer',
            responseData: 'responseData',
            eventData: 'eventData',
            images: 'images',
        }),
    },

    methods: {
        ...mapActions ({
            updateCustomer: 'updateCustomer',
            updateResponseData: 'updateResponseData',
            startAgain: 'startAgain',
        }),

        submit(event) {
            let _this = this

            // Are we already loading?
            if (this.loading == true) { return }

            // Clear the response, this clear any error messages so they don't trigger visual responses
            this.response = []

            this.loading = true

            this.axios.post('/api/v1/online-code', {
                email:      _this.customer.email,
                event_code: _this.customer.event_code,
            })
            .then(function(response) {
                _this.loading = false
                _this.response = response.data

                if (_this.response.set_event) {
                    _this.updateResponseData(_this.response)
                }
            })
            .catch(function(error) {})
        },
    },

}
</script>
<style>
.uk-rounded {
    border-radius: 5px;
}

</style>
